import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import MapIcon from "@mui/icons-material/Map";
import DevicesIcon from "@mui/icons-material/Devices";
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import PublicIcon from "@mui/icons-material/Public";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Dashboard from "layouts/dashboard";
import ProfStats from "prof/ProfStats";
import AdminStatsDeviceHosts from "prof/AdminStatsDeviceHosts";
import AdminStatsUniversityInsights from "prof/AdminStatsUniversityInsights";
import AdminStatsCountryConversion from "prof/AdminStatsCountryConversion";
import AdminStatsStudyPlans from "prof/stats/AdminStatsStudyPlans";
import AdminStatsUsmleUsage from "prof/stats/AdminStatsUsmleUsage";
import Projects from "layouts/dashboard/components/Projects";
import StatsAccordionSection from "prof/stats/StatsAccordionSection";
import AdminStatsCountryWordCloud from "prof/stats/AdminStatsCountryWordCloud";
import AdminStatsMap from "prof/stats/AdminStatsMap";

const TAB_APPLICATION_SALES = 0;
const TAB_UNIVERSITY_STATS = 1;

export default function AdminStatsPage() {
  const [tab, setTab] = useState(TAB_APPLICATION_SALES);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={{ xs: 1, sm: 2 }} px={{ xs: 1.5, sm: 2 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="fullWidth"
          sx={{
            mb: 2,
            minHeight: 40,
            p: 0.5,
            borderRadius: "14px",
            bgcolor: (theme) =>
              theme.palette.mode === "dark"
                ? "rgba(255,255,255,0.06)"
                : "rgba(15, 23, 42, 0.05)",
            borderBottom: "none",
            "& .MuiTabs-indicator": { display: "none" },
            "& .MuiTabs-flexContainer": { gap: 0.5 },
            "& .MuiTab-root": {
              minHeight: 36,
              py: 1,
              px: { xs: 1, sm: 2 },
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "0.8rem", sm: "0.875rem" },
              borderRadius: "10px",
              color: "text.secondary",
              opacity: 1,
            },
            "& .Mui-selected": {
              color: "text.primary !important",
              bgcolor: (theme) =>
                theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : "#fff",
              boxShadow: (theme) =>
                theme.palette.mode === "dark"
                  ? "none"
                  : "0 1px 3px rgba(15, 23, 42, 0.08)",
            },
          }}
        >
          <Tab label="Application sales" id="stats-tab-0" aria-controls="stats-panel-0" />
          <Tab label="University stats" id="stats-tab-1" aria-controls="stats-panel-1" />
        </Tabs>
        <MDBox role="tabpanel" id="stats-panel-0" aria-labelledby="stats-tab-0" hidden={tab !== TAB_APPLICATION_SALES}>
          {tab === TAB_APPLICATION_SALES && <Dashboard noLayout hideMap />}
        </MDBox>
        <MDBox role="tabpanel" id="stats-panel-1" aria-labelledby="stats-tab-1" hidden={tab !== TAB_UNIVERSITY_STATS}>
          {tab === TAB_UNIVERSITY_STATS && <ProfStats noLayout />}
        </MDBox>
      </MDBox>

      <MDBox px={2} pb={1}>
        <AdminStatsCountryWordCloud />
      </MDBox>

      <MDBox px={2} pb={1}>
        <StatsAccordionSection
          id="stats-map"
          title="World map"
          subtitle="Users and subscriptions by country — hover a region for counts"
          icon={<MapIcon fontSize="small" />}
        >
          <AdminStatsMap />
        </StatsAccordionSection>

        <StatsAccordionSection
          id="stats-devices"
          title="Client devices & hosts"
          subtitle="OS versions and device models reported by the mobile app"
          icon={<DevicesIcon fontSize="small" />}
        >
          <AdminStatsDeviceHosts embedded />
        </StatsAccordionSection>

        <StatsAccordionSection
          id="stats-study-plans"
          title="Study plans"
          subtitle="Who created a plan, when they used it, and what they are studying"
          icon={<MenuBookIcon fontSize="small" />}
        >
          <AdminStatsStudyPlans />
        </StatsAccordionSection>

        <StatsAccordionSection
          id="stats-usmle"
          title="USMLE Prep"
          subtitle="How many users practice USMLE — attempts, scores, and step breakdown"
          icon={<MedicalServicesIcon fontSize="small" />}
        >
          <AdminStatsUsmleUsage />
        </StatsAccordionSection>

        <StatsAccordionSection
          id="stats-universities"
          title="Universities"
          subtitle="Aggregated sign-ups by university name (normalized buckets)"
          icon={<SchoolIcon fontSize="small" />}
        >
          <AdminStatsUniversityInsights embedded />
        </StatsAccordionSection>

        <StatsAccordionSection
          id="stats-countries"
          title="Top countries — registrations & purchases"
          subtitle="Sortable leaderboard with conversion rates"
          icon={<PublicIcon fontSize="small" />}
        >
          <AdminStatsCountryConversion embedded />
        </StatsAccordionSection>
      </MDBox>

      <MDBox px={2} pb={3}>
        <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
          Users
        </Typography>
        <Projects search="" />
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}
